require('./styles/index.scss')
import 'intersection-observer'
import 'regenerator-runtime/runtime.js'
import { hot } from 'react-hot-loader/root'
import React from 'react'
import ReactDOM from 'react-dom'
import App from './components/wrapper'

const render = (Component) => {
  const root = document.getElementById('root')
  // Only for the arabic language
  if (LANG_ID === 'ar') root.setAttribute('class', 'dir-rtl')
  return ReactDOM.render(<Component />, root)
}

render(hot(App))